// extracted by mini-css-extract-plugin
module.exports = {"bottomAd_box":"bottomAd_box-1G7nhgFO","bottomAd":"bottomAd-14ToaXCQ"};